import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import {
  SignalButton,
  SignalTextField,
  SignalTextarea,
  State,
} from '@vallift/ngl';
import { BaseComponent } from '@core/base/base-component';
import { WorkspaceAPIService } from '@core/api/workspace/services/workspace-api/workspaceAPI.service';
import type { ContactGroupResponse } from '@core/api/workspace/models/contactGroupResponse';
import type { PatchContactGroupApiResponse } from '@core/api/workspace/models/patchContactGroupApiResponse';

export interface EditGroupOverlayData {
  id: string;
  name: string;
  description?: string;
}

export type EditGroupOverlayResult = ContactGroupResponse;

@Component({
  selector: 'app-edit-group-overlay',
  standalone: true,
  imports: [SignalButton, SignalTextField, SignalTextarea],
  templateUrl: './edit-group-overlay.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditGroupOverlayComponent extends BaseComponent {
  private readonly userAPIService = inject(WorkspaceAPIService);
  private readonly dialogRef = inject(
    DialogRef<EditGroupOverlayResult | null>,
  );
  private readonly data = inject<EditGroupOverlayData>(DIALOG_DATA);

  readonly patchState = new State<PatchContactGroupApiResponse>();
  readonly name = signal(this.data.name);
  readonly description = signal(this.data.description ?? '');

  close(): void {
    this.dialogRef.close(null);
  }

  onSave(): void {
    const name = this.name().trim();
    const description = this.description().trim();

    if (!name) {
      this.toasterService.error('Enter a group name.');
      return;
    }

    this.executeRequest({
      state: this.patchState,
      request: this.userAPIService.patchContactGroup(this.data.id, {
        name,
        description,
      }),
      showLoader: true,
      handleError: true,
      onSuccess: (response) => {
        this.toasterService.success('Group updated.');
        this.dialogRef.close(response.data);
      },
    });
  }
}
